export default __webpack_public_path__ + "static/media/typo.6e9e38cd.svg";